/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UndercarriageFleetComponentSnapshotResponse
 */
export interface UndercarriageFleetComponentSnapshotResponse {
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetComponentSnapshotResponse
     */
    component?: string;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetComponentSnapshotResponse
     */
    side?: string;
    /**
     * 
     * @type {number}
     * @memberof UndercarriageFleetComponentSnapshotResponse
     */
    wearPercent?: number | null;
    /**
     * 
     * @type {string}
     * @memberof UndercarriageFleetComponentSnapshotResponse
     */
    actionType?: string | null;
}

/**
 * Check if a given object implements the UndercarriageFleetComponentSnapshotResponse interface.
 */
export function instanceOfUndercarriageFleetComponentSnapshotResponse(value: object): value is UndercarriageFleetComponentSnapshotResponse {
    return true;
}

export function UndercarriageFleetComponentSnapshotResponseFromJSON(json: any): UndercarriageFleetComponentSnapshotResponse {
    return UndercarriageFleetComponentSnapshotResponseFromJSONTyped(json, false);
}

export function UndercarriageFleetComponentSnapshotResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UndercarriageFleetComponentSnapshotResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'component': json['component'] == null ? undefined : json['component'],
        'side': json['side'] == null ? undefined : json['side'],
        'wearPercent': json['wearPercent'] == null ? undefined : json['wearPercent'],
        'actionType': json['actionType'] == null ? undefined : json['actionType'],
    };
}

export function UndercarriageFleetComponentSnapshotResponseToJSON(json: any): UndercarriageFleetComponentSnapshotResponse {
    return UndercarriageFleetComponentSnapshotResponseToJSONTyped(json, false);
}

export function UndercarriageFleetComponentSnapshotResponseToJSONTyped(value?: UndercarriageFleetComponentSnapshotResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'component': value['component'],
        'side': value['side'],
        'wearPercent': value['wearPercent'],
        'actionType': value['actionType'],
    };
}

